import styled from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

import type { BadgeSize } from './Badge';

export const BadgeRoot = styled.div<{ size: BadgeSize }>`
  display: inline-flex;
  align-items: center;
  box-sizing: content-box;
  ${props => (props.size === 'medium' ? typographyV2.uiSm : typographyV2.uiXs)};
`;
